import { FC } from "react";
import { Stack, Typography } from "@mui/material";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { FilterTriggerComponentProps } from "@/components/common/select/dropdown-select/utils/types/filterTriggerComponentProps";
import { forecastedCostOptionLabels } from "@/components/pages/resource-explorer/components/resource-explorer-card/components/resource-explorer-metadata/components/utils/constants";
import { ForecastOption } from "@/services/cloudchipr.api";

export const ResourceExplorerForecastedCostsSelectTriggerComponent: FC<
  FilterTriggerComponentProps
> = ({ onClick, open, selectedValues }) => {
  const value = selectedValues[0] as ForecastOption;
  return (
    <Stack
      bgcolor="grey.100"
      px={0.7}
      justifyContent="space-between"
      direction="row"
      onClick={onClick}
      width={110}
      alignItems="center"
      sx={{
        cursor: "pointer",
      }}
      borderRadius={1}
    >
      <Typography
        fontWeight="medium"
        color="text.secondary"
        sx={{ whiteSpace: "nowrap" }}
        variant="caption"
      >
        {forecastedCostOptionLabels.get(value)}
      </Typography>

      {open ? (
        <ArrowDropUpIcon color="action" />
      ) : (
        <ArrowDropDownIcon color="action" />
      )}
    </Stack>
  );
};
